/**
 * The ONE honest mail number (Mailroom v2 PR 3) — GET /api/mailbox/count.
 * Server rules: src/server/services/mailbox/honestCount.ts.
 */
export type MailType = "work_order" | "customer" | "city" | "bounce" | "vendor" | "fyi";

export interface MailCount {
    /** Is the viewer on the Mailroom team? Only team members are told something needs them. */
    onTeam: boolean;
    /** "N need you" — unassigned + assigned to me. 0 off the team. */
    needYou: number;
    oldestWaitingHours: number | null;
    /** "2h" / "3d" in working time, or null. */
    oldestWaitingLabel: string | null;
    team: {
        open: number;
        unassigned: number;
        /** Open, but we wrote last — waiting on them. */
        waiting: number;
        byAssignee: { userId: string; name: string; count: number }[];
    };
    byType: Record<MailType | "unsorted", { open: number; unassigned: number }>;
    /** FYI / spam still in the inbox: shown, never counted. */
    quiet: number;
}

/** Past this many working hours, what needs you turns the door amber (droppedBall's threshold). */
export const MAIL_LATE_WORKING_HOURS = 4;

/** The office's words for each type, in strip order. */
export const MAIL_TYPE_ORDER: { key: MailType | "unsorted"; label: string; short: string }[] = [
    { key: "work_order", label: "New work order", short: "Work orders" },
    { key: "customer", label: "Customer reply", short: "Customers" },
    { key: "city", label: "City / registration", short: "City" },
    { key: "bounce", label: "Didn't arrive", short: "Bounced" },
    { key: "vendor", label: "Vendor / PO", short: "Vendors" },
    { key: "unsorted", label: "Not sorted yet", short: "Unsorted" },
];
